import { LocalStorage } from "@/utils/LocalStorage";
import { LocalStorageKeys } from "@/config/localStorage";

interface Token {
	Organization: Dryp.OrganizationId;
	SecurityStampClaim: string;
	aud: string;
	exp: number;
	iss: string;
	jti: string;
	nbf: number;
	sub: string;
	"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": Dryp.UserId;
	"http://schemas.microsoft.com/ws/2008/06/identity/claims/role"?: string | string[];
}

interface UserAndOrganizationId extends Dryp.User {
	organizationId: Dryp.OrganizationId;
	roles: string[];
}

export class UserStorage {
	static getUser(): UserAndOrganizationId | null {
		const token = this.getToken();
		const decodedToken = token && UserStorage.decodeToken(token);
		return decodedToken ? this.extractUserFromDecodedToken(decodedToken) : null;
	}

	static setToken(token: string): void {
		LocalStorage.set(LocalStorageKeys.TOKEN, token);
	}

	static getToken(): string | null {
		return LocalStorage.get(LocalStorageKeys.TOKEN);
	}
	// change hasToke isToken or hasToken
	static hasToken(): boolean {
		return !!this.getToken();
	}

	static removeToken(): void {
		LocalStorage.remove(LocalStorageKeys.TOKEN);
	}

	static setRefreshToken(refreshToken: string): void {
		LocalStorage.set(LocalStorageKeys.REFRESH_TOKEN, refreshToken);
	}

	static getRefreshToken(): string | null {
		return LocalStorage.get(LocalStorageKeys.REFRESH_TOKEN);
	}

	static removeRefreshToken(): void {
		LocalStorage.remove(LocalStorageKeys.REFRESH_TOKEN);
	}

	private static decodeToken(token: string): Token | null {
		try {
			const payload = token?.split(".")[1];
			const decoded = atob(payload);
			return JSON.parse(decoded);
		} catch (error) {
			console.error("Failed to decode token:", error);
			return null;
		}
	}

	private static extractUserFromDecodedToken(decoded: Token): UserAndOrganizationId {
		const rolesRaw = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
		const roles = Array.isArray(rolesRaw) ? rolesRaw : rolesRaw ? [rolesRaw] : [];
		return {
			name: decoded.sub,
			organizationId: decoded.Organization,
			id: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
			roles,
		};
	}
}
